const SuppressionQueryKeys = {
  statuses: ["suppressions", "statuses"] as const,
};

export { SuppressionQueryKeys };
